module.exports = __webpack_public_path__ + "static/1195018048.7aa3f6a8.jpg";